import React from 'react'
import { ViewReportList, statementColumnDefinition } from 'pages/reports'
import {
  useGetMovementsReportQuery,
  useLazyGetMovementsReportQuery,
} from 'features'
import { ErrorBoundary, DateRangePicker, ListView, FilterBar } from 'components'
import { format } from 'date-fns'
import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import { dniFormatter } from 'formatters'
import { LazyReportExport } from '../LazyReportExport'
import { movementTypeFilterPresets } from './movementTypeFilterPresets'

export function TransfersReport({ embedded = null, reportHeader = [] }) {
  const { dni = null } = useParams()

  /**
   * Holds the value of the selected date range for the listview component query builder
   */
  const [customFilterParams, setCustomFilterParams] = React.useState({
    fromdate: null,
    todate: format(new Date(), 'MM-dd-yyyy'),
    movementType: movementTypeFilterPresets[0].value,
    state: 'p,s,c',
  })
  /**
   * update the custom filter params when the date range picker changes
   * @param {string} name
   * @param {date} value
   */
  function handleDateRangeChange(name, value) {
    setCustomFilterParams({
      ...customFilterParams,
      [name]: format(value, 'MM-dd-yyyy'),
    })
  }

  let reportHeaderWithDateRange = [
    ...reportHeader,
    ['Movimientos desde:', customFilterParams.fromdate],
    ['Movimientos hasta:', customFilterParams.todate],
    [''],
  ]

  React.useEffect(() => {}, [customFilterParams])

  const DateRangeFilter = React.useCallback(
    () => (
      <DateRangePicker
        toDate={customFilterParams.todate}
        fromDate={customFilterParams.fromdate}
        handleFromChange={(value) => handleDateRangeChange('fromdate', value)}
        handleToChange={(value) => handleDateRangeChange('todate', value)}
      />
    ),
    [customFilterParams?.todate, customFilterParams?.fromdate]
  )

  const FilterExtraActions = () => (
    <div className="flex flex-row items-center gap-4">
      <DateRangeFilter />
      <LazyReportExport
        query={useLazyGetMovementsReportQuery}
        columns={statementColumnDefinition}
        title={`Estado de cuenta`}
        fileName={`Estado de cuenta ${dni && ' - DNI: ' + dni}}`}
        reportHeader={reportHeaderWithDateRange}
        queryParams={{
          params: {
            ...customFilterParams,
            dni: dni,
          },
          paginated: false,
        }}
      />
    </div>
  )

  function handleMovementTypeChange(e) {
    setCustomFilterParams({
      ...customFilterParams,
      movementType: e.target.value,
    })
  }

  return (
    <div className="w-full">
      <ErrorBoundary fallback={<div>Error</div>}>
        <div
          className={`flex flex-row justify-between items-center ${
            !embedded ? 'mt-32' : ''
          }`}
        >
          {!embedded ? (
            <Typography variant="h2" component="p" className="text-primary">
              {dni && 'DNI: ' + dniFormatter(dni)}
            </Typography>
          ) : (
            <div></div>
          )}
        </div>
        <FilterBar
          presets={movementTypeFilterPresets}
          value={customFilterParams.movementType}
          onChange={handleMovementTypeChange}
        >
          <div className="flex-grow" />
          <FilterExtraActions />
        </FilterBar>
        <ListView
          queryHook={useGetMovementsReportQuery}
          columns={statementColumnDefinition}
          filterCustomParams={customFilterParams}
          filterPresetParamName="movementType"
          rowClickHandler={() => true}
          rowIdKey={'movementid'}
          fixedParams={{ dni: dni, movementType: 's,r,c,a,l' }}
        />
      </ErrorBoundary>
    </div>
  )
}
